<script lang="ts" setup>
  import roundedSuccessIcon from '@assets/icons/rounded-success.svg'
  import router from '@/router'
  import { useSubscriptionsStore } from '@stores/subscriptions.ts'

  const { t } = useI18n()
  const emit = defineEmits<{ close: [] }>()
  const subscriptionsStore = useSubscriptionsStore()
  const trackStore = useTrackStore()
  const onClose = () => {
    const currentPath = router.currentRoute.value.path
    if (currentPath !== '/' && !currentPath.startsWith('/c/')) {
      router.push('/')
    }
    emit('close')
  }

  onMounted(() => {
    trackStore.track('payment_success_presented', {
      payment_type: subscriptionsStore.subscription?.sub_payment_method_id,
      version: trackStore.subscriptionVersion,
    })

    setTimeout(() => {
      onClose()
    }, 2000)
  })
</script>

<template>
  <v-container
    class="pa-0 fill-height bg-background"
    fluid
  >
    <v-row class="fill-height" no-gutters>
      <v-col cols="12">
        <v-container class="fill-height d-flex align-center justify-center pa-4">
          <v-card
            class="text-center py-8 px-4 w-100"
            color="transparent"
            flat
            max-width="400"
            rounded="lg"
          >
            <!-- Success Icon -->
            <div class="mb-6">
              <v-icon :icon="roundedSuccessIcon" size="50" />
            </div>

            <!-- Success Title -->
            <v-card-title class="text-h6 font-weight-bold text-grey-100 pa-0 mb-3">
              {{ t('subscription.successful') }}
            </v-card-title>

            <!-- Success Message -->
            <v-card-text class="text-body-2 text-grey-200 pa-0 mb-8 px-5">
              {{ t('subscription.success_message') }}
            </v-card-text>

            <!-- Action Button -->
            <v-btn
              block
              class="text-white font-weight-bold text-body-1 px-8 py-3"
              color="primary"
              height="48"
              rounded="sm"
              variant="flat"
              @click="onClose()"
            >
              {{ t('ask_sina_now') }}
            </v-btn>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>

</style>
